import axios from 'axios';
import { trackPromise } from 'react-promise-tracker';

class Api {
  instance = null;

  version = 'v1';

  methods = {
    post: 'post',
    get: 'get',
    patch: 'patch',
    delete: 'delete',
  };

  tracking = true;

  constructor() {
    if (!this.instance) {
      const token = document.querySelector('[name="csrf-token"]').content;

      this.instance = axios.create({
        baseURL: `${import.meta.env.VITE_APP_API_HOST}/${this.version}`,
        responseType: 'json',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
          'X-CSRF-TOKEN': token,
        },
        withCredentials: true,
      });
    }

    return this;
  }

  pauseTracking(callable = () => {}) {
    this.instance.tracking = false;

    callable(() => {
      this.instance.tracking = true;
    });
  }

  request(options = {}) {
    return this.basic(options);
  }

  basic(options = {}) {
    if (this.instance.tracking) {
      return trackPromise(this.instance.request(options));
    } else {
      return this.instance.request(options);
    }
  }
}

export const defaultSuccessHandler =
  (callback = () => {}) =>
  (object = {}) => {
    const { data: { message } = {} } = object;
    callback(message);
  };

export const defaultErrorHandler =
  (callback = () => {}) =>
  (object = {}) => {
    const { response: { data: { error } = {} } = {} } = object;
    callback(error);
  };

export default new Api();
